import React from "react"
import { brandingData, categoriesData } from "../../../static/data"
import styles from "../../../styles/styles"
import { useNavigate } from "react-router-dom";

const categoryGradients = [
  "from-blue-500 to-blue-600",
  "from-emerald-500 to-emerald-600",
  "from-orange-500 to-orange-600",
  "from-violet-500 to-violet-600",
  "from-teal-500 to-teal-600",
  "from-pink-500 to-pink-600",
  "from-indigo-500 to-indigo-600",
  "from-rose-500 to-rose-600",
  "from-cyan-500 to-cyan-600",
  "from-amber-500 to-amber-600",
];

const Categories = () => {
    const navigate = useNavigate();
    return (
        <>
            {/* Branding Row */}
            <div className={`${styles.section} hidden sm:block`}>
                <div className="branding my-12 flex justify-between w-full shadow-sm bg-white p-5 rounded-2xl">
                    {brandingData && brandingData.map((i, index) => (
                        <div className="flex items-start group" key={index}>
                            <div className="transition-transform duration-200 group-hover:scale-110">
                              {i.icon}
                            </div>
                            <div className="px-3">
                                <h3 className="font-bold text-base text-[#222]">{i.title}</h3>
                                <p className="text-xs text-gray-500">{i.Description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Categories Grid */}
            <div
                className={`${styles.section} bg-white p-8 rounded-3xl mb-12 shadow-lg`}
                id="categories"
            >
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
                    {categoriesData &&
                        categoriesData.map((i, idx) => {
                            const handleSubmit = (i) => {
                                navigate(`/products?category=${i.title}`);
                            };
                            const gradient = categoryGradients[idx % categoryGradients.length];
                            return (
                                <div
                                    className={`w-full h-[120px] flex items-center justify-between cursor-pointer overflow-hidden bg-gradient-to-br ${gradient} text-white rounded-2xl shadow-md transition-all duration-200 hover:scale-105 hover:shadow-xl p-4`}
                                    key={i.id}
                                    onClick={() => handleSubmit(i)}
                                >
                                    <h5 className="text-[20px] font-semibold text-white drop-shadow-sm">{i.title}</h5>
                                    <img
                                        src={i.image_Url}
                                        className="w-[100px] object-cover rounded-xl shadow-sm opacity-90"
                                        alt="image"
                                    />
                                </div>
                            );
                        })}
                </div>
            </div>
        </>
    )
}

export default Categories